/**
 * Deterministic 0..1 hash from a string seed + salt — FNV-1a mixed, Mulberry-
 * style finaliser. Same inputs always give the same output, so every "live"
 * model in the dashboard (energy, occupancy, bus loading, bin fill) animates
 * with the clock without ever flickering between renders or disagreeing
 * between the API and the browser.
 *
 * Lifted from apps/web/src/lib/energyModel.ts so the API-side shuttle
 * simulator and the web-side models share one implementation.
 */
export function seedNoise(seed: string, salt: number): number {
  let h = 2166136261 ^ salt;
  for (let i = 0; i < seed.length; i++) {
    h = Math.imul(h ^ seed.charCodeAt(i), 16777619);
  }
  h += h << 13; h ^= h >>> 7;
  h += h << 3;  h ^= h >>> 17;
  h += h << 5;
  return (h >>> 0) / 4294967295;
}
